module.exports = __webpack_public_path__ + "static/media/neura.7c08cf42.png";